import React from 'react';
import './Components.css';

const SalesDashboard = ({ todaySales }) => {
  return (
    <div className="card sales-card">
      <h2>💰 Today's Sales</h2>
      <div className="sales-amount">₹{todaySales.toFixed(2)}</div>
      <p>Last updated: {new Date().toLocaleTimeString()}</p>
    </div>
  );
};

export default SalesDashboard;